import React from "react";
import { QRCodeCanvas } from "qrcode.react";

type InlineShareQRProps = {
  shareUrl: string;
};

const InlineShareQR = ({ shareUrl }: InlineShareQRProps) => {
  return (
    <div style={styles.container} data-testid="inline-share-qr">
      <div style={styles.label}>Scan to share</div>
      <div style={styles.qrWrapper}>
        <QRCodeCanvas
          value={shareUrl}
          size={70}
          level="M"
          fgColor="#1e1b4b"
          bgColor="#ffffff"
        />
      </div>
    </div>
  );
};

export default InlineShareQR;

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  label: {
    fontFamily: '"AktivGroteskEx_A_Rg", Arial, sans-serif',
    fontSize: "10px",
    color: "#6b7280",
    whiteSpace: "nowrap",
  },
  qrWrapper: {
    padding: "4px",
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
